import SiteHeaderView from "../views/site-header-view";
import SiteHeaderMobileView from "../views/site-header-mobile-view";
import SiteFooterView from "../views/site-footer-view";
import PrivacyAcceptView from "../views/privacy-accept-view";
import GalleryView from "../views/gallery-view";
import ScrollToView from "../views/scroll-to-view";
import CalendarFilterView from "../views/calendar-filter-view";
import SeasonTicketsFilterView from "../views/season-tickets-filter-view";
import DeeplinkFilterView from "../views/deeplink-filter-view";
import LoginView from "../views/login-view";
import EventsView from "../modals/views/events-view";
import EventsDropdownView from "../views/events-dropdown-view";
import AccordionView from "../views/accordion-view";
import SearchView from "../views/search-view";
import SearchResultsView from "../views/search-results-view";
import PerformanceDetailView from "../views/performance-detail-view";
import NewWindowView from "../views/new-window-view";
import PlayInlineView from "../views/play-inline-view";
import TooltipView from "../views/tooltip-view";
import GoogleMapView from "../views/google-maps-view";
import DropdownView from "../views/dropdown-view";
import ImageBrowserView from "../views/press-images-view";
import PressLoginView from "../views/press-login-view";
import CalendarView from "../views/calendar-view";
import EmailSignupView from "../views/email-signup-view";
import ReadMore from "../views/read-more";
import SeeMore from "../views/see-more";
import VerticalSlider from "../views/vertical-slider";
import SimpleLanguageSwitcher from "../views/simple-language-switcher";
import LanguagePopupView from "../views/language-popup";
import FavoriteButton from "../views/favorite-button";
import FavoriteCount from "../views/favorite-count";
import BlogCategory from "../views/blog-category";
import BlogCTA from "../views/blog-cta";
import BlogVideoPreview from "../views/blog-video-preview";
import BlogListReadMore from "../views/blog-list-read-more";
import BlogScroller from "../views/blog-scroller";
import ImageGallery from "../views/image-gallery";
import LityURL from "../views/lity-url";
import VideoWithTimerView from "../views/video-with-timer-view";
import MembershipPageView from "../views/membership-table-view";
import SiblingNavView from "../views/sibling-nav-view";
import DonationWidgetView from "../views/donation-widget-view";
import OnePageGivingWidgetView from "../views/one-page-giving-widget-view";
import CollectionButton from "../views/collection-button";
import SplitPanelView from "../views/split-panel-view";
import HelpscoutView from "../views/helpscout-view";
import GlobalAlertView from "../views/global-alert-view";
import DonationPopupView from "../views/donation-popup-view";
import HorizontalHeroGallery from "../views/horizontal-hero-gallery";
import ShuttleSelection from "../views/shuttle-selection";
import CalendarWidgetView from '../views/calendar-widget-view';


const config = {
    context: 'body',
    matchSelector: '[data-js-match]',
    selectBoxSelector: '[data-js-select2]',
    disabledLinkSelector: '[data-js-disable-link]',
    views: [
        {
            selector: '[data-js-view=site-header]',
            getView(options?: object) {
                return new SiteHeaderView(options);
            }
        },
        {
            selector: '[data-js-view=site-header-mobile]',
            getView(options?: object) {
                return new SiteHeaderMobileView(options);
            }
        },
        {
            selector: '[data-js-view=site-footer]',
            getView(options?: object) {
                return new SiteFooterView(options);
            }
        },
        {
            selector: '[data-js-view=privacy-accept-view]',
            getView(options?: object) {
                return new PrivacyAcceptView(options);
            }
        },
        {
            selector: '[data-js-view=new-window-view]',
            getView(options?: object) {
                console.log("NewWindowView detected")
                return new NewWindowView(options);
            }
        },
        {
            selector: '[data-js-view=play-inline]',
            getView(options?: object) {
                console.log("play inline detected")
                return new PlayInlineView(options);
            }
        },
        {
            selector: '[data-js-view=dropdown]',
            getView(options?: object) {
                console.log("dropdown detected")
                return new DropdownView(options);
            }
        },
        {
            selector: '[data-js-view=scroll-to]',
            getView(options?: object) {
                return new ScrollToView(options);
            }
        },
        {
            selector: '[data-js-view=calendar-filter]',
            getView(options?: object) {
                return new CalendarFilterView(options);
            }
        },
        {
            selector: '[data-js-view=season-tickets-filter]',
            getView(options?: object) {
                return new SeasonTicketsFilterView(options);
            }
        },
        {
            selector: '[data-js-view=deeplink-filter]',
            getView(options?: object) {
                return new DeeplinkFilterView(options);
            }
        },
        {
            selector: '[data-js-view=gallery]',
            getView(options?: object, config?: object) {
                return new GalleryView(options, config);
            }
        },
        {
            selector: '[data-js-view=accordion]',
            getView(options?: object) {
                return new AccordionView(options);
            }
        },
        {
            selector: '[data-js-view=site-header]',
            getView(options?: object, config?: object) {
                return new LoginView(options, config);
            }
        },
        {
            selector: '[data-js-view=search]',
            getView(options?: object) {
                return new SearchView(options);
            }
        },
        {
            selector: '[data-js-view=search-results-container]',
            getView(options?: object, config?: object) {
                return new SearchResultsView(options, config);
            }
        },
        {
            selector: '[data-js-view=performance-detail]',
            getView(options?: object) {
                return new PerformanceDetailView(options);
            }
        },
        {
            selector: '[data-js-view=tooltip]',
            getView(options?: object) {
                return new TooltipView(options);
            }
        },
        {
            selector: '[data-js-view=google-map]',
            getView(options?: object) {
                return new GoogleMapView(options);
            }
        },
        {
            selector: '[data-js-view=press-image-browser]',
            getView(options?: object) {
                return new ImageBrowserView(options);
            }
        },
        {
            selector: '[data-js-view=press-login]',
            getView(options?: object) {
                return new PressLoginView(options);
            }
        },
        {
            selector: '[data-js-view=calendar-holder]',
            getView(options?: object) {
                return new CalendarView(options);
            }
        },
        {
            selector: '[data-js-view=email-signup-form]',
            getView(options?: object) {
                return new EmailSignupView(options);
            }
        },
        {
            selector: '[data-js-view=readmore]',
            getView(options?: object) {
                return new ReadMore(options);
            }
        },
        {
            selector: '[data-js-view=seemore]',
            getView(options?: object) {
                return new SeeMore(options);
            }
        },
        {
            selector: '[data-js-view=vertical-slider]',
            getView(options?: object) {
                return new VerticalSlider(options);
            },
        },
        {
            selector: '[data-js-view=simple-language-switcher]',
            getView(options?: object) {
                return new SimpleLanguageSwitcher(options);
            }
        },
        {
            selector: '[data-js-view=language-popup-view]',
            getView(options?: object) {
                return new LanguagePopupView(options);
            }
        },
        {
            selector: '[data-js-view=favorite-button]',
            getView(options?: object) {
                return new FavoriteButton(options);
            }
        },
        {
            selector: '[data-js-view=favorite-count]',
            getView(options?: object) {
                return new FavoriteCount(options);
            },
        },
        {
            selector: '[data-js-view=blog-category]',
            getView(options?: object) {
                return new BlogCategory(options);
            }
        },
        {
            selector: '[data-js-view=blog-cta]',
            getView(options?: object) {
                return new BlogCTA(options);
            }
        },
        {
            selector: '[data-js-view=blog-video-preview]',
            getView(options?: object) {
                return new BlogVideoPreview(options);
            }
        },
        {
            selector: '[data-js-view=blog-list-read-more]',
            getView(options?: object) {
                return new BlogListReadMore(options);
            }
        },
        {
            selector: '[data-js-view=blog-scroller]',
            getView(options?: object) {
                return new BlogScroller(options);
            }
        },
        {
            selector: '[data-js-view=image-gallery]',
            getView(options?: object) {
                return new ImageGallery(options);
            }
        },
        {
            selector: '[data-lity-url]',
            getView(options?: object) {
                return new LityURL(options);
            }
        },
        {
            selector: '[data-video-with-timer]',
            getView(options?: object) {
                return new VideoWithTimerView(options);
            }
        },
        {
            selector: '[data-js-view=memberships]',
            getView(options?: object) {
                return new MembershipPageView(options);
            }
        },
        {
            selector: '[data-js-view=sibling-nav]',
            getView(options?: object) {
                return new SiblingNavView(options);
            }
        },
        {
            selector: '[data-js-view=donation-widget-view]',
            getView(options?: object) {
                return new DonationWidgetView(options);
            },
        },
        {
            selector: '[data-js-view=one-page-giving-widget-view]',
            getView(options?: object) {
                return new OnePageGivingWidgetView(options);
            },
        },
        {
            selector: '[data-js-view=collection-button]',
            getView(options?: object) {
                return new CollectionButton(options);
            },
        },
        {
            selector: '[data-js-view=split-panel]',
            getView(options?: object) {
                return new SplitPanelView(options);
            }
        },
        {
            selector: '[data-js-view=helpscout-view]', // helpscout won't exist until GTM adds it
            getView(options?: object) {
                return new HelpscoutView(options);
            }
        },
        {
            selector: '[data-js-view=global-alert]',
            getView(options?: object) {
                return new GlobalAlertView(options);
            }
        },
        {
            selector: '[data-js-view=donation-popup]',
            getView(options?: object) {
                return new DonationPopupView(options);
            }
        },
        {
            selector: '[data-js-view=horizontal-hero-gallery]',
            getView(options?: object, config?: object) {
                return new HorizontalHeroGallery(options, config);
            }
        },
        {
            selector: '[data-js-view=shuttle-selection]',
            getView(options?: object) {
                return new ShuttleSelection(options);
            }
        },
        {
            selector: '[data-js-view=calendar-widget-view]',
            getView(options?: object) {
                return new CalendarWidgetView(options);
            },
        },
    ],
};

export { config };



// WEBPACK FOOTER //
// ./@modules/config/detector-config.ts